module.exports = __webpack_public_path__ + "static/media/mainInfo_Icon_warning.5e2a48dd.gif";